import React from "react";
import PropTypes from "prop-types";

export const Twitter = ({ color = "#1CB7EB" }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4_72)">
<path d="M13.8087 11.0606L19.7682 4.28572H18.356L13.1814 10.1683L9.0485 4.28572H4.28168L10.5314 13.1812L4.28168 20.2857H5.69395L11.1584 14.0735L15.5231 20.2857H20.2899L13.8084 11.0606H13.8087ZM11.8744 13.2596L11.2412 12.3738L6.20281 5.32546H8.37198L12.438 11.0137L13.0713 11.8995L18.3566 19.2933H16.1875L11.8744 13.2599V13.2596Z" fill="#242424"/>
</g>
<defs>
<clipPath id="clip0_4_72">
<rect width="15.4286" height="15.4286" fill="white" transform="translate(4.28577 4.28572)"/>
</clipPath>
</defs>
</svg>

  );
};
Twitter.propTypes = {
  color: PropTypes.string,
};
